var _excluded = ["className", "as", "level"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../font-scale-categories.css";
var classes = {
  h1: styles.h1,
  h2: styles.h2,
  h3: styles.h3,
  h4: styles.h4
};
var H = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    givenComponentToRender = _ref.as,
    level = _ref.level,
    props = _objectWithoutProperties(_ref, _excluded);
  var ComponentToRender = givenComponentToRender;
  var headerClass = "h".concat(level);
  if (!ComponentToRender) {
    ComponentToRender = headerClass;
  }
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: "".concat(className, " ").concat(classes[headerClass])
  }, props));
});
H.defaultProps = {
  className: ''
};
process.env.NODE_ENV !== "production" ? H.propTypes = {
  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
  /**
   * Component to render. Defaults to h1, h2, h3, h4.
   */
  as: PropTypes.elementType,
  /**
   * Header level to render
   */
  level: PropTypes.oneOf([1, 2, 3, 4]).isRequired
} : void 0;
export default H;